var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 14,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Burimet / Dokumente dhe materiale mbeshtetese te trajnimit",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1206,
    transform: "translate(-265 -394)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 199"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -116.5,
    y: -97.5,
    width: 270,
    height: 140,
    rx: 7.5,
    stroke: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vazhdo button"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100.5,
    y: -12.5,
    width: 128,
    height: 39,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -100.5,
    y: -12.5,
    width: 128,
    height: 39,
    rx: 7.5,
    stroke: "#E73529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 3",
    d: "M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1L4.5 1ZM3.64645 13.3536C3.84171 13.5488 4.15829 13.5488 4.35355 13.3536L7.53553 10.1716C7.7308 9.97631 7.7308 9.65973 7.53553 9.46447C7.34027 9.2692 7.02369 9.2692 6.82843 9.46447L4 12.2929L1.17157 9.46447C0.97631 9.2692 0.659728 9.2692 0.464466 9.46447C0.269204 9.65973 0.269204 9.97631 0.464466 10.1716L3.64645 13.3536ZM3.5 1L3.5 13L4.5 13L4.5 1L3.5 1Z",
    fill: "#E73529"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1206,
    fill: "white",
    transform: "translate(-265 -394)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownArrow);
export default __webpack_public_path__ + "static/media/red-down-arrow.381bb69457dd77fefadfcff03275e4b0.svg";
export { ForwardRef as ReactComponent };